<template>
  <a
    href="https://exoscale.com"
    target="_blank"
    class="flex-none items-start sm:items-center md:text-base transition-colors w-[180px] mb-1"
  >
    <img
      v-if="colorMode.value === 'dark'"
      src="../assets/images/exoscale-RGB-poweredby-negative-vertical.svg"
      alt="Exoscale"
      class="w-full mt-[2px]"
    />
    <img
      v-else
      src="../assets/images/exoscale-RGB-poweredby-positive-vertical.svg"
      alt="Exoscale"
      class="w-full mt-[2px]"
    />
  </a>
  <div class="flex flex-col mb-2 text-xs items-center sm:items-end">
    <div>Swiss cloud provider</div>
    <div>Data hosted exclusively in EU</div>
  </div>
</template>
<script setup lang="ts">
const colorMode = useColorMode();
</script>
